<app-admin-form [title]="'Kentekenplaat instellingen'" [object]="settings" [withSettingsSelector]="true"
  (settingsChanged)="settings=$event">
  <app-admin-item-input
    *ngFor="let licensePlate of adminSettingsService.getAdminSetting(settings,'LicensePlateKinds').Value"
    [label]="adminSettingsService.getAdminSetting(settings,'LicensePlate_'+licensePlate+'_Description').Value"
    [labelCols]="3" [(model)]="adminSettingsService.getAdminSetting(settings,'LicensePlate_'+licensePlate+'_InternalItemNumber').Value"></app-admin-item-input>

  <app-admin-cancel-save-button [labelCols]="3"
    [saveAction]="adminSettingsService.saveSettingsBase(settings)"></app-admin-cancel-save-button>
</app-admin-form>